import { ERP_API } from '../config.js';

function buildRequestBody(params = {}) {
  const body = {
    setting_file: ERP_API.settingFile,
    sucursal_id: ERP_API.sucursalId,
    usuario_id: ERP_API.usuarioId ?? 1,
    sta: 1,
    limit: params.limit || 15,
    include_precios: true,
  };

  if (ERP_API.bodegaId) {
    body.bodega_id = ERP_API.bodegaId;
  }

  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== '' && key !== 'limit') {
      body[key] = value;
    }
  });

  return body;
}

async function fetchProductos(params) {
  if (!ERP_API.baseUrl) {
    throw new Error('ERP API no configurada');
  }

  if (!ERP_API.token) {
    throw new Error('ERP API token no configurado');
  }

  const url = `${ERP_API.baseUrl}${ERP_API.productosPath}`;
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-API-Token': ERP_API.token,
  };

  const response = await fetch(url, {
    method: 'POST',
    headers,
    body: JSON.stringify(buildRequestBody(params)),
  });

  let payload;
  try {
    payload = await response.json();
  } catch {
    throw new Error(`ERP productos: HTTP ${response.status}`);
  }

  if (!response.ok || !payload.success) {
    const message = payload?.message || payload?.error || `HTTP ${response.status}`;
    throw new Error(`ERP productos: ${message}`);
  }

  return (payload.data || []).map(normalizeProducto);
}

function normalizeProducto(row) {
  const precioLista = Array.isArray(row.precios) && row.precios.length
    ? Number(row.precios[0].valor)
    : 0;

  return {
    productoId: row.producto_id ?? row.id,
    sku: row.sku || '',
    descrip: row.descrip || '',
    medida: row.medida || '',
    existencia: row.existencia != null ? Number(row.existencia) : null,
    ultcosto: row.ultcosto != null ? Number(row.ultcosto) : 0,
    precio: precioLista || (row.ultcosto != null ? Number(row.ultcosto) : 0),
  };
}

export async function searchProductosBySku(term, { partial = true } = {}) {
  const trimmed = term?.trim();
  if (!trimmed || trimmed.length < 2) return [];

  const params = partial
    ? { sku: trimmed, sku_partial: true }
    : { sku: trimmed };

  return fetchProductos(params);
}

export async function searchProductosByDescrip(term) {
  const trimmed = term?.trim();
  if (!trimmed || trimmed.length < 2) return [];

  return fetchProductos({ descrip: trimmed });
}

export async function searchProductosGeneral(term) {
  const trimmed = term?.trim();
  if (!trimmed || trimmed.length < 2) return [];

  return fetchProductos({ search: trimmed });
}

export async function getProductoBySkuExact(sku) {
  const trimmed = sku?.trim();
  if (!trimmed) return null;

  const items = await fetchProductos({ sku: trimmed, limit: 1 });
  return items.find((p) => p.sku.toLowerCase() === trimmed.toLowerCase()) || items[0] || null;
}
